<template>
  <div class="progress-bar-container hide-sm" :class="isHidden">
    <div class="p">{{completeInt}}% complete</div>
    <div class="bar-outer">
      <div class="bar-progress" v-bind:style="barSize"></div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['complete', 'hidden'],
    data () {
      return {
        completeInt: 0,
        intervals: []
      }
      
    },
    computed: {
      barSize () {
        return {
          'width': this.completeInt + '%' 
        }
      },
      isHidden () {
        if (this.hidden) {
          return 'progress-hidden'
        } else {
          return ''
        }
      }
    },
    watch: {
      complete () { // increment progress bar
        let curr = parseInt((this.complete * 100).toFixed())

        // round up to 100% complete
        if (curr > 96) curr = 100

        // clear previous actions
        for(let i = 0; i < this.intervals.length; i ++) {
          clearInterval(this.intervals[i])
        }

        this.intervals.push(setInterval(() => {
        
          if (this.completeInt === curr) {
            for (let i = 0; i < this.intervals.length; i ++) {
              clearInterval(this.intervals[i])
            }
          } else if (this.completeInt > curr) {   
            this.completeInt = this.completeInt - 1
          } else {
            this.completeInt = this.completeInt + 1
          }

        }, 100))

      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../styles/variables';

  .progress-bar-container {
    position: fixed;
    z-index: 1;
    pointer-events: none;
    top: 0;
    right: 0;
    margin-top: 12px;
    margin-right: 80px;
    width: 220px;
    transition: all $transition-1;
    .p {
      color: $orange;
    }
    &.progress-hidden {
      opacity: 0;
    }
    @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
      position: absolute;
    }
  }

  .bar-outer {
    position: relative;
    width: 100%;
    height: 6px;
    background: $light-orange;
  }

  .bar-progress {
    position: absolute;
    width: 25%;
    height: 100%;
    background: $orange;
    transition: all 0.8s ease;
  }
</style>


// WEBPACK FOOTER //
// progressBar.vue?1d8c2b3c